import angular from 'angular';
import generalBusinessDetailsComponent from './general-business-details.component';

let generalBusinessDetailsModule = angular.module('generalBusinessDetails', [])
  .component('generalBusinessDetails', generalBusinessDetailsComponent);

export default generalBusinessDetailsModule;



// WEBPACK FOOTER //
// ./client/pages/expenses/general-business-details/general-business-details.js